import { FormContextValues } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { referralTranslationKeys } from '../translations';

const UNIT_NAME_AND_ADDRESS_FIELD_NAME = 'unitNameAndAddress';
type UnitNameAndAddressFormBeanPart = {
   [UNIT_NAME_AND_ADDRESS_FIELD_NAME]: string | null;
};
type UnitNameAndAddressFieldProps = {
   readonly register: FormContextValues<UnitNameAndAddressFormBeanPart>['register'];
};

export const UnitNameAndAddressTextarea = (props: UnitNameAndAddressFieldProps): JSX.Element => {
   return (
      <Textarea
         placeholder={referralTranslationKeys.insertUnitNameAndAddress}
         rows={3}
         maxRows={5}
         maxLength={100}
         focus={false}
         label={referralTranslationKeys.unitNameAndAddress}
         controller={props.register(UNIT_NAME_AND_ADDRESS_FIELD_NAME)}
         testId={'unitNameAndAddress'}
      />
   );
};
